<template>
    <div class=" users-container reportCoursesWeeduc">
    
        
        <!-- Cards -->
        <div class="cards-container">
            <div class="card">
                <h4>Total de Matrículas</h4>
                <p>{{ totalEnrols }}</p>
            </div>
            <div class="card">
                <h4>{{ isMobile ? 'Finalizados' : 'Cursos Finalizados' }}</h4>
                <p>{{ totalEndedCourses }}</p>
            </div>
            <div class="card">
                <h4>{{ isMobile ? 'Certificados' : 'Total de Certificados' }}</h4>
                <p>{{ totalCertificated }}</p>
            </div>
            <div class="card">
                <h4>{{ isMobile ? 'Mais Vendido' : 'Curso Mais Vendido' }}</h4>
                <p>{{ mostSellCourse.courseName }} ({{ mostSellCourse.quantity }})</p>
            </div>
        </div>
        <AdvancedFilters 
        ref="advancedFilters"
        :show-date-filter="true"
        :show-course-filter="true"
        :show-user-filter="true"
        @filters-applied="onFiltersApplied"
        @filters-cleared="onFiltersCleared"
    />

        <Loader v-if="!hasReady" />
        <div v-else>
            <v-table class="custom-table table-with-filters">
                <thead>
                    <tr>
                        <th style="width: 20%; text-align: left;" class="sortable-header" @click="sortBy('userName')">
                            Nome do Aluno
                            <fa icon="fa-solid fa-sort" class="sort-icon" />
                        </th>
                        <th style="width: 20%; text-align: left;" class="sortable-header" @click="sortBy('courseName')">
                            Nome do Curso
                            <fa icon="fa-solid fa-sort" class="sort-icon" />
                        </th>
                        <th style="width: 15%; text-align: left;" class="sortable-header" @click="sortBy('dateApproved')">
                            Data de Aprovação
                            <fa icon="fa-solid fa-sort" class="sort-icon" />
                        </th>
                        <th style="width: 15%; text-align: left;" class="sortable-header" @click="sortBy('orderTotal')">
                            Total do Pedido
                            <fa icon="fa-solid fa-sort" class="sort-icon" />
                        </th>
                        <th style="width: 15%; text-align: left;" class="sortable-header" @click="sortBy('courseDiscount')">
                            Desconto do Curso
                            <fa icon="fa-solid fa-sort" class="sort-icon" />
                        </th>
                        <th style="width: 15%; text-align: left;" class="sortable-header" @click="sortBy('coursePrice')">
                            Preço do Curso
                            <fa icon="fa-solid fa-sort" class="sort-icon" />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="enrol in paginatedCourses" :key="enrol.id">
                        <td style="width: 20%; text-align: left;">{{ enrol.userName || 'N/A' }}</td>
                        <td style="width: 20%; text-align: left;">{{ enrol.courseName || 'N/A' }}</td>
                        <td style="width: 15%; text-align: left;">
                            {{ enrol.dateApproved ? formatarData(enrol.dateApproved) : 'Não aprovado' }}
                        </td>
                        <td style="width: 15%; text-align: left;">
                            {{ formatCurrency(enrol.orderTotal) }}
                        </td>
                        <td style="width: 15%; text-align: left;">
                            {{ formatCurrency(enrol.courseDiscount) }}
                        </td>
                        <td style="width: 15%; text-align: left;">
                            {{ formatCurrency(enrol.coursePrice) }}
                        </td>
                    </tr>
                </tbody>
            </v-table>
        </div>

        <div class="pagination users-pagination">
            <v-responsive>
                <v-pagination
                    :model-value="currentPage + 1"
                    :length="totalPages"
                    :total-visible="5"
                    :disabled="!hasReady"
                    @update:model-value="onPageChange"
                >
                    <template #prev="{ props }">
                        <v-btn v-bind="props" icon variant="text">
                            <Icon name="chevronLeft" size="20" />
                        </v-btn>
                    </template>
                    <template #next="{ props }">
                        <v-btn v-bind="props" icon variant="text">
                            <Icon name="chevronRight" size="20" />
                        </v-btn>
                    </template>
                </v-pagination>
            </v-responsive>
        </div>
    </div>
</template>

<script>
import Loader from '@/components/Loader/loader.vue';
import AdvancedFilters from '@/components/Admin/Reports/AdvancedFilters.vue';
import api from "@/utils/reports.js";
import { mapState } from "vuex";
import { toast } from 'vue3-toastify';

export default {
    data() {
        return {
            label: this.labels,
            userFiltered: [],
            searchTerm: '',
            status: 'all',
            currentPage: 0,
            pageSize: 10,
            alertOpenCourse: false,
            removedcoursename: '',
            afterWidth: 40,
            usersInfo: [],
            openModalCreateWarning: false,
            openModalEditWarning: false,
            hasReady: false,
            indiceItem: [false, false, false, true],
            isMobileIcon: false,
            activeFilters: {}, // Armazenar filtros ativos para export
            isMobile: false,
            totalEnrols: 0,
            mostSellCourse: [],
            totalEndedCourses: 0,
            totalCertificated: 0,
            totalPages: 0,
            currentSort: { field: '', order: 'asc' },
            courseSortOptions: [
                { value: '', text: 'Selecione...' },
                { value: 'courseName', text: 'Nome do Curso' },
                { value: 'userName', text: 'Nome do Usuário' },
                { value: 'dateApproved', text: 'Data de Aprovação' },
                { value: 'orderTotal', text: 'Total do Pedido' },
                { value: 'coursePrice', text: 'Preço do Curso' }
            ],
        };
    },
    props: {
        searchTerm: {
            type: String,
            default: ''
        },
        courseName: {
            type: String,
            default: null
        },
        labels: Array
    },
    computed: {
        ...mapState(['token', 'numberIntensTable']),
        paginatedCourses() {
            // Retornar todos os dados da página atual (já vem paginado da API)
            return this.userFiltered || [];
        },
    },
    methods: {
        checkIfMobile() {
            this.isMobile = window.matchMedia('(max-width: 600px)').matches;
        },
        async exportToCSV() {
            try {
                toast.info('Exportando relatório...');
                
                // Preparar filtros para a API de export
                const exportFilters = {};
                
                if (this.activeFilters.status) {
                    exportFilters.status = this.activeFilters.status;
                }
                if (this.activeFilters.name) {
                    exportFilters.name = this.activeFilters.name;
                }
                if (this.activeFilters.userName) {
                    exportFilters.name = this.activeFilters.userName;
                }
                if (this.activeFilters.courseName) {
                    exportFilters.courseName = this.activeFilters.courseName;
                }
                if (this.activeFilters.startDate) {
                    exportFilters.startDate = this.activeFilters.startDate;
                }
                if (this.activeFilters.endDate) {
                    exportFilters.endDate = this.activeFilters.endDate;
                }
                
                // Chamar endpoint de export
                const response = await api.getDataEnrolsExport(this.token, exportFilters);
                
                // Fazer download do arquivo blob
                const url = window.URL.createObjectURL(response);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'relatorio_matriculas.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                toast.success('Relatório exportado com sucesso!');
            } catch (error) {
                toast.error('Erro ao exportar relatório.');
                console.error('Erro ao exportar CSV:', error);
            }
        },
        async getDataReport(searchTerm = '') {
            try {
                this.hasReady = false;
                
                // Preparar filtros para a API
                const filters = {};
                
                // Aplicar filtro por nome do curso se fornecido (prioridade sobre searchTerm)
                if (this.courseName) {
                    filters.courseName = this.courseName;
                    console.log('Aplicando filtro por nome do curso:', this.courseName);
                }
                
                // Aplicar filtro por nome do usuário se searchTerm for fornecido
                if (searchTerm && searchTerm.trim() !== '') {
                    filters.name = searchTerm.trim();
                }

                const pagination = {
                    page: this.currentPage,
                    size: this.pageSize
                };

                console.log('Parâmetros enviados para API (matrículas):', filters, 'pagination:', pagination);
                const response = await api.getDataEnrols(this.token, filters, pagination);

                // Processar resposta (mesmo que vazia)
                this.usersInfo = response?.content || [];
                this.userFiltered = response?.content || [];
                this.totalEnrols = response?.totalElements || 0;
                this.totalPages = response?.totalPages || 0;
                
                // Atualizar estatísticas
                if (this.usersInfo.length > 0) {
                    this.calculateStatistics();
                } else {
                    // Se não houver dados, resetar estatísticas
                    this.totalEndedCourses = 0;
                    this.totalCertificated = 0;
                    this.mostSellCourse = { courseName: '', quantity: 0 };
                }
                
                this.hasReady = true;
                
                // Mostrar mensagem se não houver resultados
                if (this.userFiltered.length === 0 && (searchTerm || this.courseName)) {
                    toast.info('Nenhum resultado encontrado para a busca.');
                }
            } catch (error) {
                toast.error('Ocorreu um erro ao buscar os dados do relatório.');
                console.error('Erro Report Matrículas', error);
                // Garantir que mesmo em caso de erro, os dados sejam limpos
                this.usersInfo = [];
                this.userFiltered = [];
                this.totalPages = 1;
                this.totalEnrols = 0;
                this.totalEndedCourses = 0;
                this.totalCertificated = 0;
                this.mostSellCourse = { courseName: '', quantity: 0 };
                this.hasReady = true;
            }
        },
        calculateStatistics() {
            // Calculate course statistics
            const courseCount = {};
            this.usersInfo.forEach(item => {
                if (item.courseName) {
                    courseCount[item.courseName] = (courseCount[item.courseName] || 0) + 1;
                }
            });

            this.mostSellCourse = Object.entries(courseCount)
                .reduce((max, [courseName, count]) => 
                    count > max.quantity ? {courseName, quantity: count} : max,
                    {courseName: '', quantity: 0}
                );

            // Estatísticas baseadas em matrículas aprovadas
            this.totalEndedCourses = this.usersInfo.filter(
                enrol => enrol.dateApproved !== null && enrol.dateApproved !== undefined
            ).length;

            // Total de certificados (pode não estar disponível no novo formato)
            this.totalCertificated = this.usersInfo.filter(
                enrol => enrol.certificate === "1" || enrol.certificate === 1
            ).length;
        },
        async filteredUsers(searchTerm) {
            try {
                this.hasReady = false;
                
                const filters = {};
                if (searchTerm && searchTerm.trim() !== '') {
                    filters.name = searchTerm.trim();
                }
                
                const pagination = {
                    page: this.currentPage,
                    size: this.pageSize
                };
                
                const response = await api.getDataEnrols(this.token, filters, pagination);

                this.userFiltered = response?.content || [];
                this.totalEnrols = response?.totalElements || 0;
                this.totalPages = response?.totalPages || 0;
                this.hasReady = true;

            } catch (error) {
                console.error('Error fetching filtered data:', error);
                this.userFiltered = [];
                this.totalEnrols = 0;
                this.totalPages = 0;
                this.hasReady = true;
            }
        },
        handleSearch(event) {
            if (event && event.type === 'keypress' && event.key !== 'Enter') {
                return;
            }
            
            this.filteredUsers(this.searchTerm);
        },
        previousPage() {
            if (this.currentPage > 1) {
                this.currentPage = Number(this.currentPage) - 1;
            }
        },
        nextPage() {
            const total = Math.ceil(this.userFiltered.length / 10);
            if (this.currentPage < total) {
                this.currentPage = Number(this.currentPage) + 1;
            }
        },
        async onPageChange(page) {
            // Converter de 1-based (UI) para 0-based (API)
            this.currentPage = page - 1;
            await this.getDataReport();
        },
        formatarData(date) {
            if (!date) return 'N/A';
            return new Date(date).toLocaleDateString('pt-BR');
        },
        formatCurrency(value) {
            if (value === null || value === undefined || value === '') {
                return 'R$ 0,00';
            }
            
            // Converter para número se for string
            const numValue = typeof value === 'string' ? parseFloat(value) : value;
            
            // Verificar se é um número válido
            if (isNaN(numValue)) {
                return 'R$ 0,00';
            }
            
            // Formatar como moeda brasileira
            return numValue.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
        onFiltersApplied(filters) {
            this.applyAdvancedFilters(filters);
        },
        onFiltersCleared() {
            this.clearAdvancedFilters();
        },
        async applyAdvancedFilters(filters) {
            try {
                this.hasReady = false;
                
                // Armazenar filtros ativos para export
                this.activeFilters = { ...filters };
                if (filters.dateFrom) this.activeFilters.startDate = filters.dateFrom;
                if (filters.dateTo) this.activeFilters.endDate = filters.dateTo;
                
                // Resetar para primeira página ao aplicar filtros
                this.currentPage = 0;
                
                // Preparar filtros para a API
                const apiFilters = {};
                
                // Filtro por nome do curso
                if (filters.courseName && filters.courseName.trim() !== '') {
                    apiFilters.courseName = filters.courseName.trim();
                }
                
                // Filtro por nome do usuário/cliente
                if (filters.userName && filters.userName.trim() !== '') {
                    apiFilters.name = filters.userName.trim();
                }
                
                // Filtro por data
                if (filters.dateFrom) {
                    apiFilters.startDate = filters.dateFrom;
                }
                if (filters.dateTo) {
                    apiFilters.endDate = filters.dateTo;
                }
                
                const pagination = {
                    page: this.currentPage,
                    size: this.pageSize
                };
                
                // Buscar dados da API com os filtros
                console.log('Aplicando filtros via API (matrículas):', apiFilters, 'pagination:', pagination);
                const response = await api.getDataEnrols(this.token, apiFilters, pagination);
                
                // Processar resposta da API (mesmo que vazia)
                let filteredData = response?.content || [];
                this.usersInfo = filteredData; // Atualizar dados base
                
                // Ordenação local
                if (filters.sortBy) {
                    filteredData = this.sortData(filteredData, filters.sortBy, filters.sortOrder);
                }
                
                this.userFiltered = filteredData;
                this.totalEnrols = response?.totalElements || 0;
                this.totalPages = response?.totalPages || 0;
                
                // Atualizar estatísticas se houver dados
                if (filteredData.length > 0) {
                    this.calculateStatistics();
                } else {
                    // Resetar estatísticas se não houver dados
                    this.totalEndedCourses = 0;
                    this.totalCertificated = 0;
                    this.mostSellCourse = { courseName: '', quantity: 0 };
                }
                
                this.hasReady = true;
                
                // Mostrar mensagem se não houver resultados
                if (filteredData.length === 0) {
                    toast.info('Nenhum resultado encontrado para os filtros aplicados.');
                }
                
            } catch (error) {
                toast.error('Erro ao aplicar filtros.');
                console.error('Erro ao aplicar filtros:', error);
                // Garantir que mesmo em caso de erro, os dados sejam limpos
                this.userFiltered = [];
                this.usersInfo = [];
                this.totalEnrols = 0;
                this.totalEndedCourses = 0;
                this.totalCertificated = 0;
                this.mostSellCourse = { courseName: '', quantity: 0 };
                this.hasReady = true;
            }
        },
        sortData(data, sortBy, sortOrder) {
            return data.sort((a, b) => {
                let aValue, bValue;
                
                    switch (sortBy) {
                        case 'courseName':
                            aValue = (a.courseName || '').toLowerCase();
                            bValue = (b.courseName || '').toLowerCase();
                            break;
                        case 'userName':
                            aValue = (a.userName || '').toLowerCase();
                            bValue = (b.userName || '').toLowerCase();
                            break;
                        case 'dateApproved':
                            aValue = a.dateApproved ? new Date(a.dateApproved) : new Date(0);
                            bValue = b.dateApproved ? new Date(b.dateApproved) : new Date(0);
                            break;
                        case 'orderTotal':
                            aValue = parseFloat(a.orderTotal) || 0;
                            bValue = parseFloat(b.orderTotal) || 0;
                            break;
                        case 'courseDiscount':
                            aValue = parseFloat(a.courseDiscount) || 0;
                            bValue = parseFloat(b.courseDiscount) || 0;
                            break;
                        case 'coursePrice':
                            aValue = parseFloat(a.coursePrice) || 0;
                            bValue = parseFloat(b.coursePrice) || 0;
                            break;
                        default:
                            return 0;
                    }
                
                if (sortOrder === 'asc') {
                    return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
                } else {
                    return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
                }
            });
        },
        async clearAdvancedFilters() {
            try {
                this.hasReady = false;
                this.currentPage = 0;
                
                const pagination = {
                    page: this.currentPage,
                    size: this.pageSize
                };
                
                // Buscar todos os dados novamente sem filtros
                const response = await api.getDataEnrols(this.token, {}, pagination);
                this.usersInfo = response?.content || [];
                this.userFiltered = response?.content || [];
                this.totalEnrols = response?.totalElements || 0;
                this.totalPages = response?.totalPages || 0;
                
                // Atualizar estatísticas
                if (this.userFiltered.length > 0) {
                    this.calculateStatistics();
                }
                
                this.hasReady = true;
            } catch (error) {
                console.error('Erro ao limpar filtros:', error);
                this.userFiltered = [];
                this.usersInfo = [];
                this.hasReady = true;
            }
        },
        sortBy(field) {
            if (this.currentSort.field === field) {
                this.currentSort.order = this.currentSort.order === 'asc' ? 'desc' : 'asc';
            } else {
                this.currentSort.field = field;
                this.currentSort.order = 'asc';
            }
            
            this.userFiltered = this.sortData([...this.userFiltered], field, this.currentSort.order);
        }
    },
    watch: {
        courseName: {
            handler(newCourseName) {
                if (newCourseName) {
                    // Preencher o campo de filtro do AdvancedFilters
                    this.$nextTick(() => {
                        if (this.$refs.advancedFilters) {
                            this.$refs.advancedFilters.filters.courseName = newCourseName;
                        }
                    });
                    this.getDataReport();
                }
            },
            immediate: true
        }
    },
    components: {
        Loader,
        AdvancedFilters
    },
    async mounted() {
        await this.getDataReport();
        this.checkIfMobile();
        window.addEventListener('resize', this.checkIfMobile);
        
        // Preencher o campo de filtro se courseName vier da URL
        if (this.courseName && this.$refs.advancedFilters) {
            this.$refs.advancedFilters.filters.courseName = this.courseName;
        }
    },
    beforeDestroy() {
        if (this.searchDebounceTimeout) {
            clearTimeout(this.searchDebounceTimeout);
        }
    }
};
</script>

<style scoped>

.reportCoursesWeeduc .cards-container {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin-bottom: 1.5rem;
    width: 100%;
}
.reportCoursesWeeduc .card {
    background-color: #e4eef5;
    border-radius: 8px;
    padding: 1.25rem;
    flex: 1;
    min-width: 0;
    margin-top: 0px !important;
    border: none;
    max-height: 140px !important;
    justify-content: space-between;
}
.reportCoursesWeeduc .card h4 {
    margin: 0 0 0.5rem 0;
    text-align: left;
    font-size: 16px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
}
.reportCoursesWeeduc .card p {
    margin: 0;
    text-align: left;
    font-size: 42px;
    font-weight: 600;
    color: #23225f;
    word-break: break-word;
}
.reportCoursesWeeduc .cards-container .card:last-child p {
    font-size: 18px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important; 
}
.table-responsive {
    overflow-x: auto;
    width: 100%;
    margin-bottom: 1.5rem;
    -webkit-overflow-scrolling: touch;
}
.table {
    min-width: 800px;
    width: 100%;
}
/* Mobile styles */
@media (max-width: 600px) {

    .reportCoursesWeeduc .cards-container {
        flex-wrap: wrap;
        gap: 0.5rem;
    }
    .reportCoursesWeeduc .card {
        padding: 5px;
        height: auto;
        display: flex;
        flex-direction: column;
        min-width: 0;
    }
    .reportCoursesWeeduc .card:nth-child(-n+3) {
        flex: 1 1 calc(33.333% - 0.5rem);
    }
    .reportCoursesWeeduc .card:last-child {
        flex: 1 1 100%;
    }
    .reportCoursesWeeduc .card h4 {
        font-size: 12px;
        margin: 0 0 5px 0;
        min-height: 26px;
        display: flex;
        align-items: flex-start;
    }
    .reportCoursesWeeduc .card p {
        font-size: 32px;
        word-break: break-word;
        margin: 0;
    }
    .reportCoursesWeeduc .cards-container .card:last-child p {
        font-size: 18px !important;
        white-space: nowrap !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important; 
    }
}

.reportCoursesWeeduc .cards-container {
    display: flex;
    gap: 8px;
}

.search-form-input {
    position: relative;
    width: 100%;
}
.title-container .title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #000000;
    margin-bottom: 0.5rem;
}
.title-container .subtitle {
    color: #6b7280;
    font-size: 0.875rem;
    margin-bottom: 1rem;
}
.search-row {
    display: flex;
    gap: 0.75rem;
    margin-bottom: 1.5rem;
}
.search-row .form-group {
    flex: 1;
}

.export-button-container {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 1rem;
    margin-top: 1rem;
}

.export-button-container .btn-weflix {
    background-color: #2f2e8b;
    color: white;
    padding: 0.75rem 1.5rem;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 600;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(47, 46, 139, 0.2);
    border: none;
}

.export-button-container .btn-weflix:hover:not(:disabled) {
    background-color: #23225f;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(47, 46, 139, 0.3);
}

.export-button-container .btn-weflix:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
}

.export-button-container .btn-weflix svg {
    font-size: 1rem;
}

.users-container .btn-weflix.absolute {
    position: absolute;
    top: 0;
    right: 0;
    background-color: #2f2e8b;
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 600;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(47, 46, 139, 0.2);
}
.users-container .btn-weflix.absolute:hover {
    background-color: #23225f;
    transform: translateY(-2px);
}
.users-table-responsive {
    background-color: #ffffff;
    border-radius: 8px;
    margin-bottom: 1rem;
}
.users-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
}
.users-table th {
    background-color: #f8fafc;
    padding: 0.75rem;
    font-weight: 600;
    color: #4a5568;
    text-align: left;
    border-bottom: 2px solid #e2e8f0;
}
.users-table td {
    padding: 0.75rem;
    vertical-align: middle;
    border-bottom: 1px solid #f0f0f0;
    color: #4a5568;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
}
.users-table tr:hover {
    background-color: #f8fafc;
}
.badge-active, .badge-inactive {
    padding: 0.25rem 0.75rem;
    border-radius: 5px;
    font-size: 0.75rem;
    font-weight: 500;
    display: inline-block;
    text-align: center;
    transition: all 0.2s ease;
    width: 70%;
}
.badge-active {
    background-color: #7bcc8180;
    color: #4b614e;
}
.badge-inactive {
    background-color: #d7d7ee80;
    color: #2f2e8b;
}
.user-btn-edit {
    padding: 0.4rem;
    margin: 0 0.25rem;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    color: #2f2e8b;
}
.search-form-input {
    position: relative;
}
.search-form-control {
    width: 100%;
    padding: 0.5rem 0.75rem;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 0.875rem;
    transition: all 0.2s ease;
}
.search-form-control:focus {
    outline: none;
    border-color: #2f2e8b;
    box-shadow: 0 0 0 3px rgba(47, 46, 139, 0.1);
}
.search-input-icon {
    position: absolute;
    right: 0.75rem;
    top: 45%;
    transform: translateY(-50%);
    color: #9ca3af;
    cursor: pointer;
}
.users-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    margin-top: 1rem;
    padding-bottom: 10px;
}
.users-page-btn {
    padding: 0.5rem 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    background: white;
    color: #4a5568;
    cursor: pointer;
    transition: all 0.2s;
}
.users-page-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}
.users-page-btn:not(:disabled):hover {
    background: #f8fafc;
    border-color: #cbd5e0;
}
.users-page-info {
    color: #4a5568;
    font-size: 0.875rem;
}
.reportCoursesWeeduc .certificado-box {
    display: inline-block;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 14px;
    line-height: 1;
    font-weight: 500;
    text-align: center;
    white-space: nowrap;
    color: white;
}
.reportCoursesWeeduc .certificado-box.possui {
    background-color: #7bcc81;
    color: #4b614e;
}
.reportCoursesWeeduc .certificado-box.nao-possui {
    background-color: #dfdff6;
    color: #555;
}
@media (max-width: 768px) {
    .container {
        padding: 1rem;
    }

    .title-container {
        margin-bottom: 1.5rem;
    }

    .search-row {
        flex-direction: column;
    }

    .users-table th, .users-table td {
        padding: 0.5rem;
    }
}
@media (max-width: 360px) {
    .reportCoursesWeeduc .card {
        padding: 5px;
    }
    .reportCoursesWeeduc .card h4 {
        font-size: 10px;
        min-height: 24px;
    }
    .reportCoursesWeeduc .card p {
        font-size: 11px;
    }
}

select.form-control.filter-form-control {
    width: 60%;
}
.form-group.filter-form-group {
    justify-content: space-around;
    align-items: center;
    margin: 0 !important;
}
.form-group.search-form-group {
    margin: 0 !important;
}
table.table.users-table {
    border: none !important;
    padding: 0 !important;
}
button.btn-edit.user-btn-edit svg {
    color: #2f2e8b;
}
.form-group.filter-form-group {
    display: flex;
}
.btn-weflix.absolute span.flex {
    font-size: 16px;
}
.btn-weflix.absolute svg {
    color: white;
    font-size: 15px;
}
/* DARK */
.dashboard.dark .reportCoursesWeeduc .card {
    background-color: #575757 !important;
}
.dashboard.dark .reportCoursesWeeduc .card h4,
.dashboard.dark .reportCoursesWeeduc .card p,
.dashboard.dark .reportCoursesWeeduc .page-info.users-page-info {
    color: white !important;
}
.dashboard.dark .users-table-responsive {
    background-color: #000 !important;
}
.dashboard.dark .reportCoursesWeeduc .users-table th {
    border-bottom: 2px solid #575757 !important;
}
.dashboard.dark .reportCoursesWeeduc .users-table td {
    border-bottom: 2px solid #575757 !important;
}

.sortable-header {
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s ease;
    position: relative;
}

.sortable-header:hover {
    background-color: #f1f3f4;
}

.sort-icon {
    margin-left: 0.5rem;
    opacity: 0.5;
    transition: opacity 0.2s ease;
}

.sortable-header:hover .sort-icon {
    opacity: 1;
}

.dashboard.dark .sortable-header:hover {
    background-color: #666;
}

.table-with-filters {
    border-radius: 0 0 6px 6px;
    border: 1px solid #e2e8f0;
    border-top: none;
    overflow: hidden;
}

.dashboard.dark .table-with-filters {
    border-color: #444;
}
</style>
